import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { SubscriptionPlan, SubscriptionStatus } from '@vi-iot/client';

import { BookingSubscription, UserDetailsStore } from '@store';

import { SearchService } from '../../../search.service';
import { ViItemComponent } from '@vi-iot/ui/index';
import { CommonStandaloneModule } from 'src/app/shared/common-standalone.module';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { CancelBookingDirective } from '@directives';

@Component({
  selector: 'app-flat-rate-row',
  standalone: true,
  imports: [
    CommonStandaloneModule,
    CancelBookingDirective,
    ViItemComponent,
    MatIconModule,
    MatMenuModule,
  ],
  templateUrl: './flat-rate-row.component.html',
  styleUrls: ['./flat-rate-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlatRateRowComponent implements OnInit {
  @Input() subscription: BookingSubscription;
  @Input() companyId: string;

  readonly subscriptionsStatusType = SubscriptionStatus;
  readonly subscriptionPlan = SubscriptionPlan;

  leftDays: string;
  title: string;
  isCancelMenuVisible: boolean;

  constructor(public userDetailsStore: UserDetailsStore, private searchService: SearchService) {}

  ngOnInit(): void {
    this.leftDays = this.searchService.getLeftDays(this.subscription.expirationDate);
    this.title = this.searchService.getBookingDateLabel(this.subscription);
    this.isCancelMenuVisible = this.searchService.isCancellingPackagePossible(this.subscription);
  }
}
